import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CountryFlag, COUNTRY_NAME } from "@/lib/identity";

export default function CountryWar({ compact = false }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const { data } = await api.get("/season/country-war");
        if (!cancelled) setRows(data);
      } catch { /* ignore */ }
    };
    load();
    const id = setInterval(load, 15000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  if (rows.length < 2) return null;
  const total = rows[0].total_score + rows[1].total_score || 1;

  if (compact) {
    return (
      <div className="flex items-center gap-3 text-xs">
        {rows.map((r) => (
          <span key={r.country} className="flex items-center gap-1.5">
            <CountryFlag country={r.country} size={12} />
            <span className="font-mono text-nk-text">{r.total_score.toLocaleString()}</span>
          </span>
        ))}
      </div>
    );
  }

  return (
    <div className="nk-card p-6">
      <div className="flex items-baseline justify-between mb-5">
        <p className="eyebrow">The Country War</p>
        <span className="text-xs text-nk-dim">Live · this season</span>
      </div>
      <div className="space-y-4">
        {rows.map((r) => {
          const pct = (r.total_score / total) * 100;
          return (
            <div key={r.country}>
              <div className="flex items-baseline justify-between mb-2">
                <span className="flex items-center gap-2 text-lg">
                  <CountryFlag country={r.country} size={18} />
                  <span className="font-display text-xl font-medium">{COUNTRY_NAME[r.country]}</span>
                  <span className="text-xs text-nk-dim ml-2">{r.player_count.toLocaleString()} players</span>
                </span>
                <span className="font-display text-2xl font-medium text-nk-accent">
                  {r.total_score.toLocaleString()}
                </span>
              </div>
              <div className="h-2 bg-nk-line rounded-full overflow-hidden">
                <div className="h-full bg-nk-accent transition-all" style={{ width: `${pct}%` }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
